import Qs from 'qs';

export default {
  async fetchData({ commit, state, rootGetters }) {
    commit('setLoading', true);
    try {
      const params = {
        filters: {
          ...(state.filters.authorSlug && { authorSlug: state.filters.authorSlug }),
          ...(state.filters.categorySlug && { categorySlug: state.filters.categorySlug }),
          ...(state.filters.query && { titleLike: state.filters.query }),
          sectionId: 61,
        },
        limit:
          state.pagination.currentPage === 1 &&
          state.additionalOffset > 0 &&
          state.filters.query === ''
            ? state.pagination.limit + 1
            : state.pagination.limit,
        offset:
          (state.pagination.currentPage === 1 && state.additionalOffset > 0) ||
          (state.pagination.currentPage !== 1 && state.filters.query !== '')
            ? state.pagination.offset
            : state.pagination.offset + state.additionalOffset,
        orderBy: 'createdAt',
        orderDirection: 'DESC',
      };
      const {
        data: { contents, countTotal },
      } = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/contents`, {
        params,
        paramsSerializer: params => {
          return Qs.stringify(params);
        },
        useCache: true,
      });
      commit('setPagination', {
        value: {
          ...state.pagination,
          countTotal,
        },
      });
      if (process.server) {
        commit('setLoading', false);
      } else {
        setTimeout(() => {
          commit('setLoading', false);
        }, 250);
      }
      commit('setItems', { value: contents });
    } catch {
      commit('setLoading', false);
    }
  },
  async fetchAutocomplete({ commit, state }) {
    try {
      if (state.autocompleteSource) {
        state.autocompleteSource.cancel();
      }
      commit('setAutocompleteSource', this.$axios.CancelToken.source());

      if (state.filters.query === '') {
        commit('setAutocompleteData', []);
        return;
      }

      const params = {
        filters: {
          ...(state.filters.query && { titleLike: state.filters.query }),
          sectionId: 61,
        },
        orderBy: 'createdAt',
        orderDirection: 'DESC',
      };

      try {
        const {
          data: { contents },
        } = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/contents`, {
          cancelToken: state.autocompleteSource.token,
          params,
          paramsSerializer: params => {
            return Qs.stringify(params);
          },
        });
        commit('setAutocompleteData', contents);
      } catch (e) {
        commit('setAutocompleteData', []);
      }
    } catch {}
  },
  async changePagination({ commit, dispatch }, { value }) {
    try {
      commit('setPagination', { value });
      await dispatch('fetchData');
    } catch {}
  },
};
